import { EmailAvailabilityErrorCodeV1, EmailAvailabilityErrorV1 } from '@vista-digital/ocapi-client';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { CommonErrorCodes } from '../../../../types/errors/common-error-codes';
import { logger } from '../../../../utils/logger';
import { nonEmptyStringValidator } from '../../../../utils/validators/string';
import { LoyaltyDomainError, LoyaltyDomainSpecificErrorCode } from '../../types/error';
export const validateEmailAvailability = async (email) => {
    if (!nonEmptyStringValidator(email, logger.error, 'validateEmailAvailability')) {
        throw new Error('Invalid email format');
    }
    try {
        const response = await ocapiClient.instance.v1.loyalty.members.validateEmailAvailability({ email });
        return response;
    }
    catch (error) {
        throw handleEmailAvailabilityError(error);
    }
};
export const handleEmailAvailabilityError = (error) => {
    if (!(error instanceof EmailAvailabilityErrorV1))
        throw error; // Unexpected error, rethrow immediately
    const errorCode = convertApiToDomainErrorCode(error.errorCode);
    return new LoyaltyDomainError(errorCode, error.message);
};
const convertApiToDomainErrorCode = (errorCode) => {
    switch (errorCode) {
        case EmailAvailabilityErrorCodeV1.InvalidEmailFormat:
            return LoyaltyDomainSpecificErrorCode.InvalidEmailFormat;
        default:
            return CommonErrorCodes.UnknownError;
    }
};
//# sourceMappingURL=validate-email-availability.js.map